import { Model } from "@bryntum/schedulerpro";
import {HasProjectMixin} from "./mixins/HasProjectMixin.jsx";

export class ResourceType extends HasProjectMixin(Model) {
  static get $name() {
    return "ResourceType";
  }

  static get fields() {
    return [
        "description",
        "order",
    ];
  }
}

ResourceType.exposeProperties();
